import React from 'react';
import { BriefcaseIcon, CalendarIcon, DownloadIcon } from 'lucide-react';
import { Period, Producer, Role } from '../types/commission';
import { SelectMenu, SelectOption } from './SelectMenu';
interface DashboardHeaderProps {
  producer: Producer;
  role: Role;
  roles: Role[];
  onSelectRole: (roleId: string) => void;
  periods: Period[];
  selectedPeriodId: string;
  onSelectPeriod: (periodId: string) => void;
  onExport: () => void;
  isExporting: boolean;
}
export function DashboardHeader({
  producer,
  role,
  roles,
  onSelectRole,
  periods,
  selectedPeriodId,
  onSelectPeriod,
  onExport,
  isExporting
}: DashboardHeaderProps) {
  const selectedPeriod = periods.find(period => period.id === selectedPeriodId) ?? periods[0];
  const roleOptions: SelectOption[] = roles.map(item => ({
    id: item.id,
    label: item.name,
    group: item.group,
    hint: item.model === 'bps' ? `${item.baseBps} BPS base` : 'Per unit'
  }));
  const periodOptions: SelectOption[] = periods.map(period => ({
    id: period.id,
    label: period.label,
    hint: period.isCurrent ? 'In progress' : 'Closed'
  }));
  return <header className="border-b border-slate-200 bg-white" data-id="element-22" data-mp="3jrt099pifk17">
      <div className="mx-auto flex max-w-7xl flex-col gap-5 px-6 py-5 lg:flex-row lg:items-center lg:justify-between" data-id="element-23" data-mp="3ethnaq3x4ter">
        <div className="flex items-center gap-4" data-id="element-24" data-mp="39whs5a8lxb2f">
          <div aria-hidden="true" className="flex h-12 w-12 items-center justify-center rounded-xl bg-brand-900 text-sm font-bold tracking-wide text-white" data-id="element-25" data-mp="bdklp5jtots1">
            {producer.avatarInitials}
          </div>
          <div data-id="element-26" data-mp="1mg92chmdl0d">
            <p className="text-xs font-semibold uppercase tracking-widest text-brand-700" data-id="element-27" data-mp="1m6dm9dt2lna">Loan Commissions</p>
            <h1 className="text-xl font-bold text-slate-900" data-id="element-28" data-mp="3sry4xc3bk4bo">{producer.name}</h1>
            <p className="mt-0.5 text-sm text-slate-500" data-id="element-29" data-mp="u5mwi09s9fud">
              {role.name} · {producer.branch} · {producer.nmls}
            </p>
          </div>
        </div>

        {isExporting ? <div className="text-left lg:text-right" data-id="element-30" data-mp="2jmh0fpy4ybmu">
            <p className="text-xs font-semibold uppercase tracking-widest text-slate-400" data-id="element-31" data-mp="2nmj5m932xn6v">Commission statement</p>
            <p className="mt-1 text-lg font-bold text-slate-900" data-id="element-32" data-mp="29vw6wgxbjxas">
              {role.name} · {selectedPeriod.label}
            </p>
          </div> : <div className="flex flex-wrap items-center gap-3" data-id="element-33" data-mp="2escw7eg98hpg">
            <SelectMenu ariaLabel="Select role" options={roleOptions} value={role.id} onChange={onSelectRole} icon={<BriefcaseIcon className="h-4 w-4 shrink-0 text-slate-500" aria-hidden="true" data-id="element-35" data-mp="1qx1omxyncepv" />} triggerClassName="w-60" menuClassName="w-72" data-id="element-34" data-mp="1zwf2e2tszpge" />
            <SelectMenu ariaLabel="Select commission period" options={periodOptions} value={selectedPeriodId} onChange={onSelectPeriod} icon={<CalendarIcon className="h-4 w-4 shrink-0 text-slate-500" aria-hidden="true" data-id="element-37" data-mp="486mxzema9ew" />} triggerClassName="w-48" data-id="element-36" data-mp="3lajewsqfrpol" />
            <button type="button" onClick={onExport} className="inline-flex items-center gap-2 rounded-lg bg-brand-700 px-3.5 py-2 text-sm font-semibold text-white transition hover:bg-brand-800" data-id="element-38" data-mp="3vfrenzo5hg2u">
              <DownloadIcon className="h-4 w-4" aria-hidden="true" data-id="element-39" data-mp="myodbxbz8sx3" />
              Export statement
            </button>
          </div>}
      </div>
    </header>;
}